import React from 'react';
import { ConfigProvider, Result, Button } from 'antd';
import MaxAvailPage from './components/MaxAvailPage';
import './App.css';

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Application error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title="Something went wrong"
          subTitle="An unexpected error occurred. Please try refreshing the page."
          extra={
            <Button type="primary" onClick={() => window.location.reload()}>
              Refresh Page
            </Button>
          }
        />
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#13a89e',
        },
      }}
    >
      <ErrorBoundary>
        <div className="App">
          <MaxAvailPage />
        </div>
      </ErrorBoundary>
    </ConfigProvider>
  );
}

export default App;
